import { render } from "./user-editor.vue?vue&type=template&id=65b3c83b&lang=pug"
import script from "./user-editor.vue?vue&type=script&lang=js"
export * from "./user-editor.vue?vue&type=script&lang=js"

import "./user-editor.vue?vue&type=style&index=0&id=65b3c83b&lang=scss"

import exportComponent from "C:\\m-tech\\WMExtranet2.0\\WebUI\\WiseApp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__